import React, { useEffect, useState } from "react";
import "./index.css";
import TextInput from "../../InputGroup";
import ConfirmationModal from "../../AppDialogs/ConfirmationModal";
import * as dialogResults from "../../../../constatns/dialogs";
import * as Utils from "../../../../models/utils";
import domtoimage from "dom-to-image";
import jsPDF from "jspdf";

export default function Plan({ plan, lang, onInvoiceClick }) {
  // const { hover, options, userInfo, nameIntent } = this.state;
  const [showModal, setShowModal] = useState(false);
  const [nameIntent, setNameIntent] = useState("");
  const [userInfo, setUserInfo] = useState({
    name: "",
    nationalNumber: "",
    postalCode: "",
    address: "",
    city: "",
    phone: "",
    fax: "",
  });

  const onModalResult = (res) => {
    if (res === dialogResults.OK) {
      if (userInfo.name) {
        let pdfInfo = {
          userInfo: userInfo,
          selectedPlan: plan.planName,
          plan: plan,
          price: plan.totalPrice,
        };
        onInvoiceClick(pdfInfo);
        generateDPF(500);
        setShowModal(false);
        setNameIntent("");
      } else {
        setNameIntent("danger");
      }
    } else {
      setShowModal(false);
      setNameIntent("");
    }
  };

  const changeHandler = (value, key) => {
    setUserInfo((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };

  const generateTitle = (planMaxActiveMembers) => {
    switch (planMaxActiveMembers) {
      case 1:
        return "تک کاربره (حقیقی)";
      case 2:
        return "دو کاربره (حقوقی)";
      case 5:
        return "پنج کاربره";
      case 10:
        return "ده کاربره ";
      case 20:
        return "بیست کاربره";
      default:
        break;
    }
  };

  const generateDPF = (delay) => {
    setTimeout(() => {
      let input = document.getElementById("pre-invoice-pdf");
      input.style.display = "block";
      domtoimage
        .toPng(input)
        .then(function (png) {
          let pdf = new jsPDF("div", "mm", [1000, 650], false);
          pdf.addImage(png, "PNG", 10, 5, "", "", "", "SLOW", "");
          //.addImage(imageData, format, x, y, w, h, alias, compression, rotation)
          pdf.save(`${"pre-invoice"}.pdf`);
          input.style.display = "none";
        })
        .catch(function (error) {
          console.error("something went wrong - ", error);
        });
    }, delay);
  };

  const handleClick = () => {
    setShowModal(true);
  };

  return (
    <div className={"plan-section " + (plan.maxActiveMembers > 1 ? " black" : "")}>
       <div className="plan-title">{plan.displayName || generateTitle(plan.maxActiveMembers) }</div>
      {plan.discount ? (
        <div className="plan-discount">
          <span className="plan-discount-price">
            {Utils.zeroOutLastDigits((Math.round((((plan.totalPrice / 1.10) / (1 - plan.discount))*100)/100)).toLocaleString(
              lang === "fa" ? "fa-IR" : "en"
            ))}
            &nbsp;
          </span>
          <span className="plan-discount-currency">
            {lang ? "تومان" : "Toman"}&nbsp;
          </span>
          {/* <span className="plan-discount-badge">
            {plan.discount * 100}% تخفیف
          </span> */}
        </div>
      ) : (
        <div style={{ height: "16px" }}></div>
      )}
      <div
        className="plan-price"
        style={{ marginBottom: plan.discount ? "16px" : "44px" }}
      >
        <span className="plan-price-amount">
          {plan.discountPrice ? (
            <span style={{ color: "#00a796" }}>{plan.discount}</span>
          ) : (
            <span style={{ color: plan.discount ? "rgb(89, 193, 184)" : "#fff" }}>
              {Math.ceil(plan.totalPrice / 1.10).toLocaleString(
                lang === "fa" ? "fa-IR" : "en"
              )}
            </span>
          )}
          &nbsp;
        </span>
        <span className="plan-price-currency">{lang ? "تومان" : "Toman"}</span>
      </div>
      <div className="plan-subscription">
        <div className="plan-subscription-period">
          <span className="plan-subscription-period-title">مدت اشتراک:</span>
          <span className="plan-subscription-period-amount">
            {plan.duration.toLocaleString(
                lang === "fa" ? "fa-IR" : "en"
              )} ماه
          </span>
        </div>
        <div className="plan-subscription-users">
          <span className="plan-subscription-users-title">تعداد کاربران:</span>
          <span className="plan-subscription-users-amount">
            {(plan.maxActiveMembers > 1 ? 'حداکثر ' :'')+ plan.maxActiveMembers.toLocaleString(
                lang === "fa" ? "fa-IR" : "en"
              )} نفر
          </span>
        </div>
      </div>
      <div>
        <a href="https://www.bourseview.com/home/#/upgrade/plans">
          <button className="purchase-btn" style={{ marginBottom: "16px" }}>
            خرید
          </button>
        </a>
      </div>
      <div>
        <button className="preinvoice-btn" onClick={handleClick}>
          صدور پیش فاکتور
        </button>
      </div>
      <ConfirmationModal
        style={{ width: "680px" }}
        bodyStyle={{ height: "335px", margin: "10px 20px" }}
        show={showModal}
        title={""}
        result={onModalResult}
        showConfirm={true}
        confirmName={"تایید"}
      >
        <div className="plan-section-confirmation-modal-wrapper">
          <h3 className="text-align-center">
            {lang === "fa"
              ? "لطفا موارد زیر را تکمیل نمایید"
              : "Please fill the following fields"}
          </h3>
          <TextInput
            value={userInfo.name}
            required
            label={"نام شخص حقیقی/حقوقی:"}
            vertical={false}
            intent={nameIntent}
            onChange={(value) => changeHandler(value, "name")}
          />
          <TextInput
            value={userInfo.nationalNumber}
            label={"شماره ملی:"}
            vertical={false}
            intent={""}
            onChange={(value) => changeHandler(value, "nationalNumber")}
          />
          {/* <TextInput value={userInfo.registrationNumber} label={'شماره ثبت:'} vertical={false} intent={''} onChange={(value)=>this.changeHandler(value,'registrationNumber')}/> */}
          <TextInput
            value={userInfo.postalCode}
            label={"کد پستی ۱۰ رقمی:"}
            vertical={false}
            intent={""}
            onChange={(value) => changeHandler(value, "postalCode")}
          />
          <TextInput
            value={userInfo.address}
            label={"نشانی:"}
            vertical={false}
            intent={""}
            onChange={(value) => changeHandler(value, "address")}
          />
          <TextInput
            value={userInfo.city}
            label={"شهر:"}
            vertical={false}
            intent={""}
            onChange={(value) => changeHandler(value, "city")}
          />
          <TextInput
            value={userInfo.phone}
            label={"تلفن:"}
            vertical={false}
            intent={""}
            onChange={(value) => changeHandler(value, "phone")}
          />
          <TextInput
            value={userInfo.fax}
            label={"نمابر:"}
            vertical={false}
            intent={""}
            onChange={(value) => changeHandler(value, "fax")}
          />
        </div>
      </ConfirmationModal>
    </div>
  );
}
